export const priceSources = {
  SETTLEMENT: 'SETTLEMENT',
  BESTASK: 'BESTASK',
  BESTBID: 'BESTBID',
};
